import { render, staticRenderFns } from "./Trash.vue?vue&type=template&id=14677ef0&scoped=true"
import script from "./Trash.vue?vue&type=script&lang=js"
export * from "./Trash.vue?vue&type=script&lang=js"
import style0 from "./Trash.vue?vue&type=style&index=0&id=14677ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14677ef0",
  null
  
)

export default component.exports